var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:[_vm.$style.backgroundSlides, _vm.active === 'true' ? _vm.$style.active : ''],style:([_vm.slideBackground, _vm.varian, _vm.buttonRadius])},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }